module.exports = __webpack_public_path__ + "img/动态礼物--支持定制gif.d9702ab8.gif";